export function garageUpdateLimits(config) {
  const group = (config && config.segmentGroup) || 'FIXTER';
  const settings = (config && config.garageUpdates && config.garageUpdates[group]) || {};
  const initialLimit = Number(settings.initialLimit) > 0 ? Number(settings.initialLimit) : 100;
  const batchSize = Number(settings.batchSize) > 0 ? Number(settings.batchSize) : initialLimit;
  return { initialLimit, batchSize };
}

const GARY_APP_NAME = {
  FIXTER: 'Gary',
  MOTRIO: 'WorkshopHub',
  RENAULT: 'Garage Back Office',
};

export function applicationLabel(application, segmentGroup, t) {
  if (application === 'maia') {
    return t('maia.garage.updates.application.maia', 'Maia');
  }
  // Brand names are not translated. Renault loads the Fixter catalogues, where the
  // gary key is "Gary", so a lookup would hide "Garage Back Office".
  const name = GARY_APP_NAME[segmentGroup] || 'Gary';
  if (application === 'gary_via_maia') {
    return t('maia.garage.updates.application.viaMaia', '{name} via Maia', { name });
  }
  return name;
}
